import React, { FC, HTMLProps, useState } from "react";
import dateFnsGenerateConfig from "rc-picker/lib/generate/dateFns";
import Picker, { PickerProps } from "rc-picker";
import { useStore } from "effector-react";
import { getPopupContainer } from "../../shared/getPopupContainer";
import cn from "classnames";
import inputStl from "../Input/Input.module.scss";
import { nanoid } from "nanoid";
import format from "date-fns/format";
import { $currentLocale } from "../../store/shared/locales";

interface Props extends Omit<PickerProps<Date>, "generateConfig" | "locale"> {
  label?: string;
  containerProps?: HTMLProps<HTMLInputElement>;
  labelProps?: HTMLProps<HTMLLabelElement>;
}
export type DatePickerProps = Props;
type Value = Date | null | undefined;
const DatePicker: FC<Props> = ({
  className,
  containerProps,
  label,
  labelProps,
  value,
  onChange,
  ...props
}) => {
  const { rcPickerLocale: locale } = useStore($currentLocale);
  const [id] = useState<string>(nanoid());
  const [isFocused, setIsFocused] = useState<boolean>(false);

  const [localValue, setLocalValue] = useState<Value>();

  const displayValue = value ?? localValue;

  const onChanges = (v: Value) => {
    onChange?.(
      v ?? null,
      v ? format(v, props.format as string) : "Invalid Date"
    );
    setLocalValue(v);
  };

  return (
    <div
      {...containerProps}
      className={cn(containerProps?.className, inputStl.block)}
    >
      {label && (
        <label
          htmlFor={id}
          {...labelProps}
          className={cn(labelProps?.className, {
            [inputStl.labelShrink]: displayValue || isFocused,
          })}
        >
          {label}
        </label>
      )}
      <Picker
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        id={id}
        className={cn(className)}
        inputReadOnly
        getPopupContainer={getPopupContainer}
        allowClear
        format={"dd-MM-yyyy"}
        {...props}
        value={displayValue}
        onChange={onChanges}
        locale={locale}
        generateConfig={dateFnsGenerateConfig}
      />
    </div>
  );
};

export default DatePicker;
